import React, { useContext } from 'react';
import { I18nReactContext } from '../../../../../../contexts/I18nContext';

/**
 * Shape type selector section
 * Only handles shape type selection (rectangle/circle)
 * Background, border, and opacity controls are handled by AppearanceSection
 * @param {object} props - Component props
 * @param {object} props.component - The component being edited
 * @param {function} props.onContentChange - Callback when content changes
 */
export const ShapeTypeSection = ({ component, onContentChange }) => {
    const { i18n } = useContext(I18nReactContext);

    return (
        <div className="menu-section">
            <h4>{i18n.translate('weezbeeCourse.editor.editorDrawer.shapeType', { defaultValue: 'Shape Type' })}</h4>
            <div className="shape-selector">
                {['rectangle', 'circle'].map(shapeType => (
                    <button
                        key={shapeType}
                        className={`shape-option ${component.shapeType === shapeType ? 'active' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            onContentChange(component.id, shapeType, { shapeType });
                        }}
                        title={i18n.translate(`weezbeeCourse.editor.shapeComponent.${shapeType}`, { defaultValue: shapeType })}
                    >
                        <div className={`shape-preview shape-${shapeType}`}></div>
                        <span>{i18n.translate(`weezbeeCourse.editor.shapeComponent.${shapeType}`, { defaultValue: shapeType })}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};
